/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'

// material-ui
import { Container, Box, Grid, Divider } from '@material-ui/core'

// custom components
import LatestArticle from './LatestArticle'
import LatestProject from './LatestProject'
import ArticlesByMonths from './ArticlesTreeView'

/**
 * Landing page for the site
 * @returns {*}
 * @constructor
 */
function LandingPage({ navigate }) {
  return (
    <React.Fragment>
      <Container maxWidth="lg">
        <Box pt={1} pb={1}>
          <Divider variant="fullWidth" />
        </Box>
        <LatestArticle />
        <Box pt={1} pb={1}>
          <Divider variant="fullWidth" />
        </Box>
        <Grid container spacing={2}>
          {/* Main content */}
          <Grid item xs={12} md={8}>
            <LatestProject />
          </Grid>
          {/* End main content */}
          {/* Sidebar */}
          <Grid item xs={12} md={4}>
            <ArticlesByMonths navigate={navigate} />
          </Grid>
          {/* End sidebar */}
        </Grid>
      </Container>
    </React.Fragment>
  )
}

export default LandingPage
